import { Platform } from 'quasar'

export function download(url, title) {
    if (Platform.is.cordova && Platform.is.ios) {
        window.open(url, '_system')
    }
    else if (Platform.cordova && Platform.is.android) {

        let uriString = url
        let notificationTitle = `${i18next.$t('downloading')} ${title}`

        window.resolveLocalFileSystemURL(cordova.file.externalRootDirectory, (rootDirectory) => {

            rootDirectory.getDirectory('download', { create: true },  (downloadDirectory) => {

                downloadDirectory.getDirectory(process.env.PROJECT_FOLDER, { create: true }, (projectDirectory) => {

                    projectDirectory.getFile(fileName, { create: true }, (targetFile) => {
                        let downloader = new BackgroundTransfer.BackgroundDownloader()
                        let download = downloader.createDownload(uriString, targetFile, notificationTitle)

                        download.startAsync().then(
                            (e) => {
                                console.log('download finished')
                            },
                            (e) => {
                                console.log('download failed')
                            },
                            (e) => {
                                console.log(e)
                            }
                        )
                    })
                })
            })
        })
    }
    else {
        window.open(url, '_blank')
    }
}

export default { download }